import fetch from "./fetch";
/**
 * 病例管理
 */
const caseManage = {
  //活动分页
  getActivity(params) {
    return fetch({
      isLoading: true,
      url: "/diseaseCase/page",
      method: "GET",
      params,
    });
  },
  //模糊查询模板
  // getRemoteTemplate(params) {
  //   return fetch({
  //     isLoading: true,
  //     url: "/questionnaireType/selectByType",
  //     method: "GET",
  //     params,
  //   });
  // },
  //删除活动
  deleteActivity(data) {
    return fetch({
      isLoading: true,
      url: "/diseaseCase/delete",
      method: "POST",
      data,
    });
  },
  //创建活动
  createActivity(data) {
    return fetch({
      isLoading: true,
      url: "/diseaseCase/save",
      method: "POST",
      data,
    });
  },
  //修改活动
  updateActivity(data) {
    return fetch({
      isLoading: true,
      url: "/diseaseCase/update",
      method: "POST",
      data,
    });
  },

  //病例审核分页
  getAuditProcessPage(params) {
    return fetch({
      isLoading: true,
      url: "/AuditProcess/page",
      method: "GET",
      params,
    });
  },

  /**
   * 根据病例id查找审核记录
   */
  getAuditLog(params) {
    return fetch({
      isLoading: true,
      url: "/AuditProcess/auditLogging",
      method: "GET",
      params,
    });
  },

  /**
   * 模糊查询活动
   */
  getRemoteActivity(params) {
    return fetch({
      isLoading: true,
      url: "/diseaseCase/caseActivity",
      method: "GET",
      params,
    });
  },

  /**
   * 提交审核
   */
  saveAudit(data) {
    return fetch({
      isLoading: true,
      url: "/AuditProcess/save",
      method: "POST",
      data,
    });
  },
};

export default caseManage;
